import { useState } from "react";
import Point from './Point';

const useGameBoard = () => {
    let initialData = [
        -1, -1, 1, 1, 1, -1, -1, -1, -1, 1, 1, 1, -1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, -1, 1, 1, 1, -1, -1, -1, -1, 1, 1,
        1, -1, -1,
    ];
  const [board, setBoard] = useState(initialData);
  const [hotCell, setHotCell] = useState(-1);
  const [gameState, setGameState] = useState(false);
  const [pegsRemoved, setPegsRemoved] = useState(0);
 
  const movePeg = (to) => {
    if(board[to]===-1) return;
    if(to === hotCell) return;
    if(board[to] === 1) {
      setHotCell(to);
      return;
    }
    let newBoard = board.slice();
    if(isValidMove(hotCell, to, newBoard) === false) return;        
    
    let fromPoint = Point.createFromIndex(hotCell);
    let toPoint = Point.createFromIndex(to);
    
    newBoard[to] = 1;
    newBoard[hotCell] = 0;
    let center = getMidIndex(fromPoint, toPoint);
    newBoard[center] = 0;
    setBoard(newBoard);

    let remainingPegs = 0;
    newBoard.forEach((x) =>  {
      if(x===1) remainingPegs++;
    });
    let score = 32 - remainingPegs;   
    setPegsRemoved(score);    
    setHotCell(-1);
    let gameOver = isGameOver(newBoard);
    setGameState(gameOver);
  }

  const canMove = (from, boardData) =>{
    if(boardData[from]!==1) return [];

    let validMoves = []
    let fromPoint = Point.createFromIndex(from);
    //top    
    if(fromPoint.above().above().isValid()){
      let to = fromPoint.above().above().convertToIndex();
      let mid = fromPoint.above().convertToIndex();
      if(boardData[to]===0 && boardData[mid] === 1) validMoves.push(to);      
    }

    if(fromPoint.below().below().isValid()){
      let to = fromPoint.below().below().convertToIndex();
      let mid = fromPoint.below().convertToIndex();
      if(boardData[to]===0 && boardData[mid] === 1) validMoves.push(to);
    }

    if(fromPoint.right().right().isValid()){
      let to = fromPoint.right().right().convertToIndex();
      let mid = fromPoint.right().convertToIndex();
      if(boardData[to]===0 && boardData[mid] === 1) validMoves.push(to);
    }

    if(fromPoint.left().left().left()){
      let to = fromPoint.left().left().convertToIndex();
      let mid = fromPoint.left().convertToIndex();
      if(boardData[to]===0 && boardData[mid] === 1) validMoves.push(to);
    }
    // if(validMoves.length > 0)
    //   console.log('D', from, validMoves);
    return validMoves;

  }

  const getMidIndex = (fromPoint, toPoint) => {
    if(fromPoint.x === toPoint.x){
      if(fromPoint.above().above().y == toPoint.y){
        return fromPoint.above().convertToIndex();
      }
      if(fromPoint.below().below().y == toPoint.y){
        return fromPoint.below().convertToIndex();
      }
    }
    if(fromPoint.y === toPoint.y){
      if(fromPoint.right().right().x === toPoint.x){
        return fromPoint.right().convertToIndex();
      }
      if(fromPoint.left().left().x === toPoint.x){
        return fromPoint.left().convertToIndex();
      }
    }

  }
  
  const isValidMove = (from, to, boardData) => {
    let possibleMoves = canMove(from, boardData);
    //console.log('E', possibleMoves);
    return (possibleMoves.indexOf(to)!==-1);
  }
 
  const isGameOver = (boardData) => {   
    for(let i=0;i<boardData.length;i++){ 
      let moves = canMove(i, boardData);
      if(moves.length > 0){        
        console.log('game still active', moves, i, boardData[i]);
        return false;
      }      
    } 
    console.log('game over');
    return true;
  }

  const resetBoard = () =>{
    setBoard(initialData);
    setHotCell(-1);
    setGameState(false);
    setPegsRemoved(0);
  }

  return [
    board,
    hotCell,
    gameState,
    movePeg,
    resetBoard,
    pegsRemoved,
  ];
};

export default useGameBoard;